import {
  getFileInfo,
  getFolderInfo,
  getSingleFolderWithFiles,
  getTreeClassName,
  reorderArrayFromOderKey
} from "./common";
import FileTreeConfig from "./FileTreeConfig";
import { getFieldLabelByType } from "../Config/DefaultConfig/formFieldConfig";
import { generateObjectId } from "../objectIdUtils";
import fileFolderConfig from "../../commonFunctions/fileFolderConfig";

export const getTableFieldsTree = (allFields) => {
  const tableObject = {};
  const fieldIDObject = {};

  const array = [
    "lookup",
    "lookup-sm",
    "app-user",
    // "community-user",
    "recordset",
    "recordset-list",
    "owner",
    "owner-list",
    "activities_owner",
    "allowed_activities_fields",
    "object",
    "object[]"
  ];
  const getSingleTableField = (data, sub) => {
    const ans = [];
    data.forEach((field) => {
      if (array.includes(field.data_type)) {
        const subFieldFolder = FileTreeConfig.getFolderConfig(
          sub ? sub.id + "." + field.id : field.id,
          field.display + ` [${getFieldLabelByType(field.field_type)}]`,
          "",
          false,
          field.field_type === "recordset-list" ||
            field.field_type === "grid" ||
            field.field_type === "lookup-sm" ||
            field.field_type === "lookup" ||
            field.field_type === "owner" ||
            field.field_type === "phone" ||
            field.field_type === "app-user",
          false,
          "popup",
          getTreeClassName(field)
        );
        const copy = JSON.parse(JSON.stringify(field));
        if (sub) {
          copy.prefix = (sub.prefix || "") + "." + copy.display; //for showing parent path
          copy.parent_type = (sub.field_type || "") + "." + copy.field_type; //parent type is field inside lookup or appuser
          copy.data_key = sub.data_key + (copy.data_key ? "." + copy.data_key : "");
          copy.id = sub.id + (copy.id ? "." + copy.id : "");
          copy.parent_table_id = (sub.parent_table_id || "") + "." + (copy.table_id || "");
        } else {
          copy.prefix = copy.activity_label + "." + copy.display;
          copy.parent_table_id = copy.table_id || "";
        }
        const subFieldArray = getSingleTableField(field.sub_fields || [], copy);
        subFieldFolder.items = subFieldArray;
        tableObject[copy.id] = copy;
        fieldIDObject[field.id] = field;
        ans.push(subFieldFolder);
      } else {
        const copy = JSON.parse(JSON.stringify(field));
        if (sub) {
          copy.prefix = sub.prefix || "";
          copy.parent_type = sub.field_type || "";
          copy.data_key = sub.data_key + (copy.data_key ? "." + copy.data_key : "");
          copy.id = sub.id + (copy.id ? "." + copy.id : "");
          copy.parent_table_id = sub.parent_table_id || "";
        } else {
          copy.prefix = copy.activity_label;
        }
        tableObject[copy.id] = copy;
        fieldIDObject[field.id] = field;
        const singleField = FileTreeConfig.getFileConfig(copy.id, copy.display, null, null, null, {}, copy.field_type);
        ans.push(singleField);
      }
    });

    return ans;
  };
  const treeData = getSingleTableField(allFields);
  return { treeData, tableObject, fieldIDObject };
};

export const getTreeDataForStateMachine = (type, data) => {
  if (type === "single") {
    data.states = reorderArrayFromOderKey(data.states);
    data.activities = reorderArrayFromOderKey(data.activities);

    return getSingleStateMachineConfig(data);
  }

  if (type === "all") {
    return data.map((statemachine) => {
      statemachine.states = reorderArrayFromOderKey(statemachine.states);
      statemachine.activities = reorderArrayFromOderKey(statemachine.activities);

      return getSingleStateMachineConfig(statemachine);
    });
  }
};

const prefixItemsWithSMId = (smId, folderName, items = []) => {
  return (items || []).map((item, idx) => {
    const raw = item?.id ?? item?.key ?? item?.name ?? `item-${idx}`;
    const rawStr = String(raw);

    // If already prefixed, leave it
    if (rawStr.startsWith(`${smId}/`)) return { ...item, id: rawStr };

    return { ...item, id: `${smId}/${folderName}/${rawStr}` };
  });
};

const getSingleStateMachineConfig = (statemachine) => {
  const { id, name, sm_type } = statemachine;

  const namespacedStates = prefixItemsWithSMId(id, "states", reorderArrayFromOderKey(statemachine.states || []));

  const namespacedActivities = prefixItemsWithSMId(
    id,
    "activities",
    reorderArrayFromOderKey(statemachine.activities || [])
  );

  // Root node (state machine folder)
  let singleStateMachine = FileTreeConfig.getFolderConfig(
    id,
    name,
    `${id}/statemachine`,
    true, // isFolder
    false, // expanded
    true, // draggable
    "inline",
    "",
    false,
    getFolderInfo("statemachine", statemachine)
  );

  // Child folders
  const states = getSingleFolderWithFiles(`${id}/states`, "states", namespacedStates, `${id}/states`, id);

  const activities = getSingleFolderWithFiles(
    `${id}/activities`,
    "activities",
    namespacedActivities,
    `${id}/activities`,
    id
  );

  singleStateMachine.items.push(states);
  singleStateMachine.items.push(activities);
  singleStateMachine.type = sm_type;

  return singleStateMachine;
};

export const getTreeDataForJobs = (data) => {
  const forRecordsView = getSingleFolderWithFiles("1", "jobs", data);
  return [forRecordsView];
};

export const getTreeDataForCron = (data) => {
  const forRecordsView = getSingleFolderWithFiles("1", "cron", data);
  return [forRecordsView];
};

export const getTreeDataForAppUserFields = (data) => {
  const { treeData, tableObject } = getTableFieldsTree(data);
  return { treeData, tableObject };
};

export const getTreeDataForWorkflow = (data) => {
  const forRecordsView = getSingleFolderWithFiles("1", "workflow", data);
  return [forRecordsView];
};

export const getTreeDataForSqlTemplates = (data) => {
  const RdbmsTemplate = getSingleFolderWithFiles("rdbms", "MySQL", data[0], "rdbms", "rdbms", false, true);
  const postgresTemplate = getSingleFolderWithFiles(
    "postgres",
    "Postgres",
    data[1],
    "postgres",
    "postgres",
    false,
    true
  );
  return [RdbmsTemplate, postgresTemplate];
};

export const getTreeDataForScreens = (data, folderTagsData) => {
  const folderTags = folderTagsData?.reduce((acc, tag) => {
    acc[tag.id] = tag.name;
    return acc;
  }, {});

  const organizeByFolderTags = (items) => {
    const folderStructure = {
      untagged: []
    };

    items.forEach((item) => {
      if (item.folder_info_tag && item.folder_info_tag.length > 0) {
        item.folder_info_tag.forEach((tagId) => {
          if (!folderStructure[tagId]) {
            folderStructure[tagId] = [];
          }
          folderStructure[tagId].push(item);
        });
      } else {
        folderStructure.untagged.push(item);
      }
    });

    return folderStructure;
  };

  const createDeviceFolder = (deviceName, deviceData) => {
    const mainFolder = FileTreeConfig.getFolderConfig(deviceName, `${deviceName}/screen`, "", false, false);

    const organizedItems = organizeByFolderTags(reorderArrayFromOderKey(deviceData));
    const folderItems = [];

    Object.entries(organizedItems).forEach(([tagId, items]) => {
      const folderName = folderTags?.[tagId] || `Folder ${tagId}`;
      if (tagId !== "untagged") {
        const folderConfig = FileTreeConfig.getFolderConfig(
          `${deviceName}-${tagId}`,
          folderName,
          deviceName,
          true,
          false
        );
        folderConfig.items = items.map((item) =>
          FileTreeConfig.getFileConfig(
            item.id,
            item.name,
            `${deviceName}/screen`,
            item.can_delete,
            item.can_edit,
            getFileInfo(`${deviceName}/screen`, item),
            item.type
          )
        );
        folderItems.push(folderConfig);
      }
    });

    mainFolder.items = [
      ...folderItems,
      ...organizedItems.untagged.map((item) =>
        FileTreeConfig.getFileConfig(
          item.id,
          item.name,
          `${deviceName}/screen`,
          item.can_delete,
          item.can_edit,
          getFileInfo(`${deviceName}/screen`, item),
          item.type
        )
      )
    ];

    return mainFolder;
  };

  const forDesktop = createDeviceFolder("desktop", data.desktop);
  const forTablet = createDeviceFolder("tablet", data.tablet);
  const forMobile = createDeviceFolder("mobile", data.mobile);

  return [forDesktop, forMobile, forTablet];
};

export const getTreeDataForPublicScreens = (data) => {
  const forDesktop = getSingleFolderWithFiles("desktop", "desktop", data.desktop);
  const forMobile = getSingleFolderWithFiles("mobile", "mobile", data.mobile);
  const forForm = getSingleFolderWithFiles("publicform", "publicform", data.form);

  return [forDesktop, forMobile, forForm];
};

export const getTreeDataForApiInOut = (apiData) => {
  const { webhook, httpTemp } = apiData;

  const apiInOutData = getSingleFolderWithFiles("webhook", "Web Hook", webhook, "webhook", "", false, true, "popup");
  const httpTempData = getSingleFolderWithFiles(
    "http-request-templates",
    "Http Request Template",
    httpTemp,
    "http-request-templates",
    "",
    false,
    true,
    "inline"
  );
  const activityWebhookData = getSingleFolderWithFiles(
    "activity-webhook",
    "Activity Webhook",
    apiData.activityWebhook,
    "activity-webhook",
    "",
    false,
    true,
    "popup"
  );

  const hardcodedPipeline = [
    {
      id: "pipeline",
      name: "Pipelines",
      can_delete: false,
      can_edit: false
    }
  ];

  const pipelinesData = getSingleFolderWithFiles(
    "pipelines",
    "Pipelines",
    hardcodedPipeline,
    "pipelines",
    "",
    false,
    false,
    "none"
  );

  return [apiInOutData, httpTempData, activityWebhookData, pipelinesData];
};

export const getTreeDataForRdbmsFields = (data) => {
  const fieldsData = getTableFieldsTree(data);
  let treeData = fieldsData.treeData;
  let tableObject = fieldsData.tableObject;
  let fieldIDObject = fieldsData.fieldIDObject;
  return { treeData, tableObject, fieldIDObject };
};

export const getTreeDataForJobsCategory = (jobs) => {
  const groupedObject = jobs.reduce((result, obj) => {
    const { category } = obj;
    if (!result[category]) {
      result[category] = [];
    }
    result[category].push(obj);
    return result;
  }, {});
  const categoryList = Object.keys(groupedObject);
  if (categoryList.length === 0) {
    return [];
  } else {
    const folders = categoryList.map((category) => {
      return getSingleFolderWithFiles(category, category, groupedObject[category], category, category);
    });
    return folders;
  }
};

export const getTreeDataForForm = (data) => {
  const folders = [];

  const entitiesFolder = FileTreeConfig.getFolderConfig("1", "entities", "", false, false);

  data?.entities?.forEach((entity) => {
    const entityFile = FileTreeConfig.getFileConfig(
      `${entity.sm_id}/statemachine/${entity.activity_id}`, // updated ID with prefix
      entity.activity_name === "Init Activity" ? entity.sm_name : `${entity.sm_name} +`,
      `${entity.sm_id}/entities`,
      false,
      false,
      "",
      "entities"
    );
    entitiesFolder.items.push(entityFile);
  });

  folders.push(entitiesFolder);

  const smFolder = FileTreeConfig.getFolderConfig("2", "SM-Workflow", "", false, false);

  data?.statemachines?.forEach((sm) => {
    const smNameFolder = FileTreeConfig.getFolderConfig(sm.sm_id, sm.sm_name, "", false, false);

    smNameFolder.items = sm.activities.map((activity) => {
      return FileTreeConfig.getFileConfig(
        `${sm.sm_id}/statemachine/${activity.activity_id}`, // updated id
        activity.activity_name,
        `${sm.sm_id}/statemachine`, // updated path
        false,
        false,
        "",
        "statemachine"
      );
    });
    smFolder.items.push(smNameFolder);
  });

  folders.push(smFolder);

  const customFunctionFolder = FileTreeConfig.getFolderConfig("3", "Custom Function", "custom_function", false, true);

  data?.custom_function?.forEach((cus_func) => {
    const entityFile = FileTreeConfig.getFileConfig(
      `customfunction/${cus_func.id}`, // prefix added
      cus_func.name,
      "custom_function",
      true,
      true,
      "",
      "custom_function"
    );

    customFunctionFolder.items.push(entityFile);
  });

  folders.push(customFunctionFolder);

  const subformFolder = FileTreeConfig.getFolderConfig("4", "Subform", "subform", false, true, true, "popup");

  data?.subform?.forEach((subform) => {
    const singleSubForm = FileTreeConfig.getFileConfig(
      `subform/${subform.id}`, // prefix added
      subform.name,
      `${subform.config.table_id || ""}/statemachine`,
      true,
      true,
      "",
      "subform"
    );
    subformFolder.items.push(singleSubForm);
  });

  folders.push(subformFolder);

  return folders;
};

export const getTreeDataForApplicationBlock = (data) => {
  const finalData = ["desktop", "mobile", "tablet"].map((device) => {
    const deviceFolder = FileTreeConfig.getFolderConfig(device, device, "applicationblock", false, false);
    const subFolder = [
      "recordsview",
      "detailsview",
      "chart",
      "pivotcharts",
      "queryblocks",
      "activitycard",
      "progress-bar"
    ].map((type, index) => {
      return getSingleFolderWithFiles(
        device + "/" + type,
        type,
        reorderArrayFromOderKey(data[index][device]),
        device + "/" + type,
        device,
        false,
        true,
        "popup"
      );
    });
    deviceFolder.items = subFolder;
    return deviceFolder;
  });
  return finalData;
};

export const getTreeDataForTemplates = (data) => {
  const EmailTemplate = getSingleFolderWithFiles("email", "email", data[0], "email", "email", false, true);
  const SmsTemplate = getSingleFolderWithFiles("sms", "sms", data[1], "sms", "sms", false, true);

  const MasterDataTemplate = getSingleFolderWithFiles(
    "masterdata",
    "masterdata",
    data[2],
    "masterdata",
    "masterdata",
    false,
    true,
    "popup"
  );

  const pdfTemplate = getSingleFolderWithFiles(
    "pdf_template",
    "pdf template",
    data[3],
    "pdf_template",
    "pdf_template",
    false,
    true
  );
  const googleDoc = getSingleFolderWithFiles(
    "googledoc",
    "docs template",
    data[4],
    "googledoc",
    "googledoc",
    false,
    true
  );
  const accessTemp = getSingleFolderWithFiles(
    "access-templates",
    "Access Control Templates",
    data[5],
    "access-templates",
    "access-templates",
    false,
    true
  );
  const mongoTemplate = getSingleFolderWithFiles(
    "mongo-template",
    "Mongo Templates",
    data[6],
    "mongo-template",
    "mongo-template",
    false,
    true
  );
  const recordviewTempalte = getSingleFolderWithFiles(
    "recordview-template",
    "Recordview Templates",
    data[7],
    "recordview-template",
    "recordview-template",
    false,
    true
  );
  const excelTemplate = getSingleFolderWithFiles(
    "exceldoc",
    "Excel Templates",
    data[8],
    "exceldoc",
    "exceldoc",
    false,
    true
  );
  const OcrTemplate = getSingleFolderWithFiles("ocr", "OCR", data[9], "ocr", "ocr", false, true);

  const reactCompTemplate = getSingleFolderWithFiles(
    "custom-component",
    "React Components",
    data[10],
    "custom-component",
    "custom-component",
    false,
    true
  );
  const aiTemplate = getSingleFolderWithFiles(
    "ai-assistant-template",
    "Ai Assistant",
    data[11],
    "ai-assistant-template",
    "ai-assistant-template",
    false,
    true
  );
  const apiForwardingTemplate = getSingleFolderWithFiles(
    "api-forwarding-template",
    "Egress",
    data[12],
    "api-forwarding-template",
    "api-forwarding-template",
    false,
    true
  );

  return [
    EmailTemplate,
    SmsTemplate,
    pdfTemplate,
    excelTemplate,
    googleDoc,
    accessTemp,
    MasterDataTemplate,
    mongoTemplate,
    recordviewTempalte,
    OcrTemplate,
    reactCompTemplate,
    aiTemplate,
    apiForwardingTemplate
  ];
};

export const getTreeDataForEntity = (data) => {
  const allList = data.map((file) => {
    let flag = file?.can_delete;

    return FileTreeConfig.getFileConfig(file.id, file.name, "entity", flag, true, getFileInfo("entity", file));
  });
  return [...allList];
};

export const getTreeDataForRdbmsForm = (data) => {
  const folders = [];

  const rdbmsFolder = FileTreeConfig.getFolderConfig("5", "Forms", "rdbmsform", false, true, true, "popup");

  data?.rdbmsForm?.forEach((rdbms) => {
    const singleRdbmsForm = FileTreeConfig.getFileConfig(
      rdbms.id,
      rdbms.name,
      `rdbmsform`,
      true,
      true,
      "",
      "rdbmsform"
    );
    rdbmsFolder.items.push(singleRdbmsForm);
  });

  folders.push(rdbmsFolder);
  return folders;
};

export const getTreeDataForTableFields = (data) => {
  let tableObject = {};
  let fieldIDObject = {};

  const treeData = data.map((activity) => {
    const activityFolder = FileTreeConfig.getFolderConfig(
      activity.activity_id || generateObjectId(),
      activity.name,
      "",
      false,
      false,
      false,
      "",
      getTreeClassName(activity)
    );
    const fieldsData = getTableFieldsTree(activity.items);
    activityFolder.items = fieldsData.treeData;
    tableObject = { ...tableObject, ...fieldsData.tableObject };
    fieldIDObject = { ...fieldIDObject, ...fieldsData.fieldIDObject };
    return activityFolder;
  });
  return { treeData, tableObject, fieldIDObject };
};

// export const getTreeDataForCommunityFields = (data) => {
//   const { treeData, tableObject } = getTableFieldsTree(data);
//   return { treeData, tableObject };
// };

export const getTreeDataForConnectors = (data) => {
  const emailFolder = fileFolderConfig.getFolderConfig("email_connectors", "Email Connectors", "", false, true);
  emailFolder.items = data.email.map((e) => {
    return fileFolderConfig.getFileConfig(e.id, e.name, "email_connectors", true, false);
  });
  return [emailFolder];
};
